var gql = require("@apollo/client").gql;

const INFO_VARIABLES_TARIFFS_QUERY = gql`
    query INFO_VARIABLES_TARIFFS_QUERY(
        $region_url: String
        $region_id: Int
        $provider_url: String
        $provider_id: Int
        $operator_url: String
        $operator_id: Int
        $find_operator: Int
        $tagCode: String
        $tagType: String
    ) {
        infoVariablesTariffs(
            region_url: $region_url
            region_id: $region_id
            provider_url: $provider_url
            provider_id: $provider_id
            operator_url: $operator_url
            operator_id: $operator_id
            find_operator: $find_operator
            tagCode: $tagCode
            tagType: $tagType
        ) {
            countTariffs
            price {
                max
                min
            }
            price_internet_tv_mobile {
                max
                min
            }
            price_internet_tv {
                max
                min
            }
        }
    }
`;

export default INFO_VARIABLES_TARIFFS_QUERY;
